import axios from "axios"
import { useState } from "react"
import queryString from 'query-string'
import { get_property_reports_traffic } from "../../api/api"


const FilterReportAge = ({ queries, setData, active, mode }) => {

    const [isLoading, setIsLoading] = useState(false)

    const handleOnClick = async (e) => {
        try {
            setData({})
            setIsLoading(true)
            const res = await axios.get(get_property_reports_traffic(queryString.stringify(queries), 1, active))
            setData({ type: 2, data: { ages: res.data }, mode: mode })
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            <button
                disabled={isLoading}
                className={`moreFiltersButton ${active?.ages ? 'active' : ''} ${mode ? 'chartModeBtn' : ''}`}
                type="button"
                onClick={handleOnClick}>{isLoading ? '...' : 'رده سنی'}
                {!isLoading && active?.ages ? ': ' + active.ages?.name : ''}
            </button>
        </>
    );
}

export default FilterReportAge;